import React from 'react';
import { useUnity } from '../../contexts/UnityContext';
import UnityViewer from './UnityViewer';

type UnitySurfaceProps = {
  viewMode?: '2d' | '3d';
  hidden?: boolean; // when true, keep Unity running but visually hidden (for 2D background loading)
};

/**
 * UnitySurface renders the UnityViewer within the GalleryPage layout,
 * wiring Unity's lifecycle events to the UnityContext.
 *
 * Note: We intentionally do NOT pass pieceId into UnityViewer to avoid double
 * SendMessage calls. Piece changes are sent via UnityContext.loadPiece().
 */
const UnitySurface: React.FC<UnitySurfaceProps> = ({ hidden = false }) => {
  const { onUnityReady, onUnityError } = useUnity();
  const className = hidden
    ? 'absolute inset-0 z-0 opacity-0 pointer-events-none'
    : 'absolute inset-0 z-0 pointer-events-auto';

  return (
    <div className={className} aria-hidden={hidden}>
      <UnityViewer onUnityReady={onUnityReady} onUnityError={onUnityError} hidden={hidden} />
    </div>
  );
};

export default UnitySurface;
